import { render, staticRenderFns } from "./AddressCardNew.vue?vue&type=template&id=f301edaa&scoped=true"
import script from "./AddressCardNew.vue?vue&type=script&lang=js"
export * from "./AddressCardNew.vue?vue&type=script&lang=js"
import style0 from "./AddressCardNew.vue?vue&type=style&index=0&id=f301edaa&prod&scoped=true&lang=css"
import style1 from "./AddressCardNew.vue?vue&type=style&index=1&id=f301edaa&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f301edaa",
  null
  
)

export default component.exports